import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { RbacService } from '@core/services/rbac/rbac.service';
import { APP_ROUTES } from '@app/app.routes.model';

export const hasAccessForActionGuard: CanActivateFn = (route) => {
  const access = inject(RbacService).hasAccessForGlobalAction(
    route.data['action'],
  );

  if (access) {
    return true;
  }

  // TODO this should point to some better route which is accessible to all e.g. dashboard
  return inject(Router).navigate([APP_ROUTES.notAllowed]);
};
